import React, { useLayoutEffect, useMemo, useRef, useState } from "react";
import styles from "./LabelsOverflow.module.scss";
import { Label } from "../common/label/Label";
import { calculateHiddenItems } from "../ExpandableItems/helpers";
import { Tooltip } from "../common/tooltip";
import { BaseLabel } from "../common/BaseLabel/BaseLabel";

type Props = {
  labels: string[];
};

export const LabelsOverflow = ({ labels }: Props) => {
  const containerRef = useRef<HTMLDivElement>(null);
  const tooltipRef = useRef<HTMLDivElement>(null);

  const [hiddenCount, setHiddenCount] = useState(0);

  const { visibleLabels, hiddenLabels } = useMemo(
    () =>
      labels.reduce<{ visibleLabels: string[]; hiddenLabels: string[] }>(
        (acc, label, index) => {
          if (index < labels.length - hiddenCount) {
            acc.visibleLabels.push(label);
          } else {
            acc.hiddenLabels.push(label);
          }
          return acc;
        },
        { visibleLabels: [], hiddenLabels: [] },
      ),
    [hiddenCount, labels],
  );

  useLayoutEffect(() => {
    if (!tooltipRef.current || !containerRef.current) return;

    let hiddenCount = calculateHiddenItems(labels.length, containerRef.current);

    if (tooltipRef.current.offsetTop > containerRef.current.offsetHeight) {
      hiddenCount += 1;
    }

    if (hiddenCount > 0) {
      setHiddenCount(hiddenCount);
    }
  }, [labels.length]);

  return (
    <div className={styles.container} ref={containerRef}>
      {visibleLabels.map((label, index) => (
        <Label key={index} text={label} />
      ))}
      <div ref={tooltipRef} className={hiddenCount > 0 ? styles.visible : styles.hidden}>
        <Tooltip
          target={
            <BaseLabel className={styles.tooltipLabel} basic>
              {hiddenLabels.length}+
            </BaseLabel>
          }
          content={hiddenLabels.join(", ")}
          showAlways
        />
      </div>
    </div>
  );
};
